import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d6eb87c6")

_pushScopeId("data-v-d6eb87c6")
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "py-16 sm:py-24 bg-white" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "mx-auto sm:px-2 lg:px-8" }, [
  /*#__PURE__*/_createVNode("div", { class: "mx-auto max-w-2xl px-4 lg:max-w-4xl lg:px-0" }, [
    /*#__PURE__*/_createVNode("h1", { class: "text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl" }, "Order history"),
    /*#__PURE__*/_createVNode("p", { class: "mt-2 text-sm text-gray-500" }, "Check the status of recent orders, manage returns, and discover similar products.")
  ])
], -1)
const _hoisted_4 = { class: "mt-16" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "sr-only" }, "Recent orders", -1)
const _hoisted_6 = { class: "mx-auto sm:px-2 lg:px-8" }
const _hoisted_7 = { class: "mx-auto max-w-2xl space-y-8 sm:px-4 lg:max-w-4xl lg:px-0" }
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Order placed on ")
const _hoisted_10 = { class: "flex items-center border-b border-gray-200 p-4 sm:grid sm:grid-cols-4 sm:gap-x-6 sm:p-6" }
const _hoisted_11 = { class: "grid flex-1 grid-cols-2 gap-x-6 text-sm sm:col-span-3 sm:grid-cols-3 lg:col-span-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("dt", { class: "font-medium text-gray-900" }, "Order number", -1)
const _hoisted_13 = { class: "mt-1 text-gray-500" }
const _hoisted_14 = { class: "hidden sm:block" }
const _hoisted_15 = /*#__PURE__*/_createVNode("dt", { class: "font-medium text-gray-900" }, "Date placed", -1)
const _hoisted_16 = { class: "mt-1 text-gray-500" }
const _hoisted_17 = /*#__PURE__*/_createVNode("dt", { class: "font-medium text-gray-900" }, "Total amount", -1)
const _hoisted_18 = { class: "mt-1 font-medium text-gray-900" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "sr-only" }
const _hoisted_21 = { class: "py-1" }
const _hoisted_22 = { class: "hidden lg:col-span-2 lg:flex lg:items-center lg:justify-end lg:space-x-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "View Order", -1)
const _hoisted_24 = { class: "sr-only" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h4", { class: "sr-only" }, "Items", -1)
const _hoisted_26 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_27 = { class: "flex items-center sm:items-start" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg bg-gray-200 sm:h-40 sm:w-40" }, null, -1)
const _hoisted_29 = { class: "ml-6 flex-1 text-sm" }
const _hoisted_30 = { class: "font-medium text-gray-900 sm:flex sm:justify-between" }
const _hoisted_31 = { class: "mt-2 sm:mt-0" }
const _hoisted_32 = { class: "hidden w-full relative text-gray-500 sm:mt-2 sm:block truncate overflow-hidden" }
const _hoisted_33 = { class: "mt-6 sm:flex sm:justify-between" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "mt-6 flex items-center space-x-4 divide-x divide-gray-200 border-t border-gray-200 pt-4 text-sm font-medium sm:mt-0 sm:ml-4 sm:border-none sm:pt-0" }
const _hoisted_36 = { class: "flex flex-1 justify-center" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "flex flex-1 justify-center pl-4" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "flex flex-1 justify-between sm:hidden" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
  }, "Previous"),
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
  }, "Next")
], -1)
const _hoisted_39 = { class: "hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" }
const _hoisted_40 = { class: "text-sm text-gray-700" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Showing " + /*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "1", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ') + " to " + /*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_44 = { class: "font-medium" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ') + " of " + /*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_46 = { class: "font-medium" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ') + " results ")
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-sm",
  "aria-label": "Pagination"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Previous", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Next", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DotsVerticalIcon = _resolveComponent("DotsVerticalIcon")
  const _component_MenuButton = _resolveComponent("MenuButton")
  const _component_MenuItem = _resolveComponent("MenuItem")
  const _component_MenuItems = _resolveComponent("MenuItems")
  const _component_Menu = _resolveComponent("Menu")
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
              return (_openBlock(), _createBlock("div", {
                key: item.id,
                class: "border-t border-b border-gray-200 bg-white shadow-sm sm:rounded-lg sm:border"
              }, [
                _createVNode("h3", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("time", {
                    datetime: item.date
                  }, _toDisplayString(item.date), 9, ["datetime"])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("dl", _hoisted_11, [
                    _createVNode("div", null, [
                      _hoisted_12,
                      _createVNode("dd", _hoisted_13, _toDisplayString(item.title), 1)
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode("dd", _hoisted_16, [
                        _createVNode("time", {
                          datetime: item.date
                        }, _toDisplayString(item.date), 9, ["datetime"])
                      ])
                    ]),
                    _createVNode("div", null, [
                      _hoisted_17,
                      _createVNode("dd", _hoisted_18, _toDisplayString(item.total), 1)
                    ])
                  ]),
                  _createVNode(_component_Menu, {
                    as: "div",
                    class: "relative flex justify-end lg:hidden"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_19, [
                        _createVNode(_component_MenuButton, { class: "-m-2 flex items-center p-2 text-gray-400 hover:text-gray-500" }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_20, "Options for order " + _toDisplayString(item.info), 1),
                            _createVNode(_component_DotsVerticalIcon, {
                              class: "h-6 w-6",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2 w-40 origin-bottom-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_21, [
                                _createVNode(_component_MenuItem, null, {
                                  default: _withId(({ active }) => [
                                    _createVNode("a", {
                                      href: item.link,
                                      class: [active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']
                                    }, "View", 10, ["href"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("a", {
                      href: item.link,
                      class: "flex items-center justify-center rounded-md border border-gray-300 bg-white py-2 px-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    }, [
                      _hoisted_23,
                      _createVNode("span", _hoisted_24, _toDisplayString(item.info), 1)
                    ], 8, ["href"])
                  ])
                ]),
                _hoisted_25,
                _createVNode("ul", _hoisted_26, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.items, (lineItem) => {
                    return (_openBlock(), _createBlock("li", {
                      key: lineItem.id,
                      class: "p-4 sm:p-6"
                    }, [
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            _createVNode("h5", null, _toDisplayString(lineItem.boostpack.title), 1),
                            _createVNode("p", _hoisted_31, _toDisplayString(lineItem.totalAmount), 1)
                          ]),
                          _createVNode("p", _hoisted_32, _toDisplayString(lineItem.boostpack.description), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _createVNode("div", _hoisted_34, [
                          _createVNode(_component_CheckCircleIcon, {
                            class: "h-5 w-5 text-green-500",
                            "aria-hidden": "true"
                          }),
                          (item.additionalInfo)
                            ? (_openBlock(), _createBlock("p", {
                                key: 0,
                                class: "ml-2 text-sm font-medium text-gray-500",
                                innerHTML: item.additionalInfo
                              }, null, 8, ["innerHTML"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_35, [
                          _createVNode("div", _hoisted_36, [
                            _createVNode("a", {
                              href: '/detail/'+lineItem.boostpack.reference,
                              class: "whitespace-nowrap text-indigo-600 hover:text-indigo-500"
                            }, "View boostpack", 8, ["href"])
                          ]),
                          _hoisted_37
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128)),
            _hoisted_38,
            _createVNode("div", _hoisted_39, [
              _createVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.paginationData) + " ", 1),
                _createVNode("p", _hoisted_40, [
                  _hoisted_41,
                  _hoisted_42,
                  _hoisted_43,
                  _createVNode("span", _hoisted_44, _toDisplayString(_ctx.paginationData.per_page), 1),
                  _hoisted_45,
                  _createVNode("span", _hoisted_46, _toDisplayString(_ctx.paginationData.total), 1),
                  _hoisted_47
                ])
              ]),
              (_ctx.paginationData.from !== _ctx.paginationData.last_page)
                ? (_openBlock(), _createBlock("div", _hoisted_48, [
                    _createVNode("nav", _hoisted_49, [
                      (_ctx.paginationData.current_page >= 1)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paginatePage(_ctx.paginationData.current_page-1))),
                            class: "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
                          }, [
                            _hoisted_50,
                            _createVNode(_component_ChevronLeftIcon, {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.paginatePage(_ctx.paginationData.current_page))),
                        "aria-current": "page",
                        class: "relative z-10 inline-flex items-center border border-indigo-500 bg-indigo-50 px-4 py-2 text-sm font-medium text-indigo-600 focus:z-20"
                      }, _toDisplayString(_ctx.paginationData.current_page), 1),
                      _createVNode("a", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paginatePage(_ctx.paginationData.current_page+1))),
                        class: "relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
                      }, [
                        _hoisted_51,
                        _createVNode(_component_ChevronRightIcon, {
                          class: "h-5 w-5",
                          "aria-hidden": "true"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
})